import React, { FC, useMemo } from "react";

import classNames from "classnames";

import { StyledProgressBar, StyledProgressBarProgress } from "./Styles";

export interface IProgressBarProps {
  /** Progress prop can be number. */
  progress: number;
  /** Custom classname for styling. */
  backgroundColor?: string;
  /** Custom classname for styling. */
  progressColor?: string;
  /** Progress height. */
  stroke?: number;
  /** Progress width in percentage. */
  width?: number;
  className?: string;
}

export const ProgressBar: FC<IProgressBarProps> = ({
  progress = 0,
  backgroundColor,
  progressColor,
  stroke = 3,
  width = 100,
  className,
}) => {
  const progressNumber = useMemo(() => {
    let width = progress;
    if (progress > 100) {
      width = 100;
    }
    if (progress < 0) {
      width = 0;
    }
    return width;
  }, [progress]);

  const widthPercent = useMemo(() => {
    let width_percent = width;

    if (width > 100) {
      width_percent = 100;
    }

    if (width <= 0) {
      width_percent = 100;
    }

    return width_percent;
  }, [width]);

  const height = useMemo(() => {
    let stroke_min = stroke;

    if (stroke <= 0) {
      stroke_min = 3;
    }

    return stroke_min;
  }, [stroke]);

  return (
    <StyledProgressBar
      className={classNames("c-progress-bar", className)}
      $color={backgroundColor}
      $width={widthPercent}
    >
      <StyledProgressBarProgress
        className="c-progress-bar__progress"
        style={{ width: `${progressNumber}%` }}
        $height={height}
        $color={progressColor}
      />
    </StyledProgressBar>
  );
};

ProgressBar.displayName = "ProgressBar";
